import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {HomeComponent} from './home/home.component';
import {LimitComponent} from './limit/limit.component';
import {CalculatorComponent} from './calculator/calculator.component';

import {IndividualCalculatorComponent} from './calculator/calculator-item/individual-calculator/individual-calculator.component';
import {BusinessCalculatorComponent} from './calculator/calculator-item/business-calculator/business-calculator.component';
import {EventsCalculatorComponent} from './calculator/calculator-item/events-calculator/events-calculator.component';

import {VehicleComponent} from './calculator/calculator-item/shared/main/vehicle/vehicle.component';
import {TransitComponent} from './calculator/calculator-item/individual-calculator/transit/transit.component';
import {IndividualTravelComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component';
import {EnergyComponent} from './calculator/calculator-item/shared/main/energy/energy.component';

import {VehicleDefaultComponent} from './calculator/calculator-item/shared/main/vehicle/vehicle-default/vehicle-default.component';
import {CarComponent} from './calculator/calculator-item/shared/main/vehicle/car/car.component';
import {EcarComponent} from './calculator/calculator-item/shared/main/vehicle/ecar/ecar.component';
import {MotorcycleComponent} from './calculator/calculator-item/shared/main/vehicle/motorcycle/motorcycle.component';
import {BoatComponent} from './calculator/calculator-item/shared/main/vehicle/boat/boat.component';
import {OptionsComponent} from './calculator/calculator-item/shared/main/vehicle/car/options/options.component';
// import {ClassComponent} from './calculator/calculator-item/shared/main/vehicle/car/class/class.component';
import {VehicleListComponent} from './calculator/calculator-item/shared/main/vehicle/vehicle-list/vehicle-list.component';

import {IndividualTravelDefaultComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-travel-default/individual-travel-default.component';
import {IndividualFlightsComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-flights/individual-flights.component';
import {IndividualMilesComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-miles/individual-miles.component';
import {IndividualFuelComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-fuel/individual-fuel.component';
import {IndividualLengthComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-length/individual-length.component';
import {IndividualFlightsListComponent} from './calculator/calculator-item/individual-calculator/individual-travel/individual-flights-list/individual-flights-list.component';

import {EnergyDefaultComponent} from './calculator/calculator-item/shared/main/energy/energy-default/energy-default.component';
import {EnergyAddComponent} from './calculator/calculator-item/shared/main/energy/energy-add/energy-add.component';

import {ThankyouComponent} from './calculator/calculator-item/shared/main/thankyou/thankyou.component';

import {EventsGateComponent} from './calculator/calculator-item/events-calculator/events-gate/events-gate.component';
import {EventsTravelComponent} from './calculator/calculator-item/events-calculator/events-travel/events-travel.component';
import {EventsCommuteComponent} from './calculator/calculator-item/events-calculator/commute/commute.component';
import {EventsTravelDefaultComponent} from './calculator/calculator-item/events-calculator/events-travel/events-travel-default/events-travel-default.component';
import {EventsLengthComponent} from './calculator/calculator-item/events-calculator/events-travel/events-length/events-length.component';
import {EventsAverageComponent} from './calculator/calculator-item/events-calculator/events-travel/events-average/events-average.component';
import {HotelComponent} from './calculator/calculator-item/events-calculator/events-travel/hotel/hotel.component';
import {VenueComponent} from './calculator/calculator-item/events-calculator/venue/venue.component';
import {WaterComponent} from './calculator/calculator-item/events-calculator/water/water.component';
import {MealsComponent} from './calculator/calculator-item/events-calculator/meals/meals.component';

import {BusinessGateComponent} from './calculator/calculator-item/business-calculator/business-gate/business-gate.component';
import {SiteComponent} from './calculator/calculator-item/business-calculator/site/site.component';
import {FleetComponent} from './calculator/calculator-item/business-calculator/fleet/fleet.component';
import {AirTravelComponent} from './calculator/calculator-item/business-calculator/air-travel/air-travel.component';
import {AirTravelDefaultComponent} from './calculator/calculator-item/business-calculator/air-travel/air-travel-default/air-travel-default.component';
import {AirTravelEmployeeComponent} from './calculator/calculator-item/business-calculator/air-travel/air-travel-employee/air-travel-employee.component';
import {AirTravelMilesComponent} from './calculator/calculator-item/business-calculator/air-travel/air-travel-miles/air-travel-miles.component';
import {CommuteComponent} from './calculator/calculator-item/business-calculator/commute/commute.component';
import {ShippingComponent} from './calculator/calculator-item/business-calculator/shipping/shipping.component';
import {ServerComponent} from './calculator/calculator-item/business-calculator/server/server.component';
import {SiteDefaultComponent} from './calculator/calculator-item/business-calculator/site/site-default/site-default.component';
import {SiteAddComponent} from './calculator/calculator-item/business-calculator/site/site-add/site-add.component';
import {FleetDefaultComponent} from './calculator/calculator-item/business-calculator/fleet/fleet-default/fleet-default.component';
import {FleetCarComponent} from './calculator/calculator-item/business-calculator/fleet/fleet-car/fleet-car.component';
import {FleetBoatComponent} from './calculator/calculator-item/business-calculator/fleet/fleet-boat/fleet-boat.component';
import {FleetEcarComponent} from './calculator/calculator-item/business-calculator/fleet/fleet-ecar/fleet-ecar.component';
import {FleetListComponent} from './calculator/calculator-item/business-calculator/fleet/fleet-list/fleet-list.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: '',
        component: CalculatorComponent,
        children: [
            {
                path: 'individual',
                component: IndividualCalculatorComponent,
                children: [
                    {
                        path: 'vehicle',
                        component: VehicleComponent,
                        children: [
                            {
                                path: 'default',
                                component: VehicleDefaultComponent,
                            },
                            {
                                path: 'car',
                                component: CarComponent,
                            },
                            {
                                path: 'ecar',
                                component: EcarComponent
                            },
                            {
                                path: 'motorcycle',
                                component: MotorcycleComponent
                            },
                            {
                                path: 'boat',
                                component: BoatComponent
                            },
                            {
                                path: 'options',
                                component: OptionsComponent,
                            },
                            // {
                            //     path: 'class',
                            //     component: ClassComponent,
                            // },
                            {
                                path: 'list',
                                component: VehicleListComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'transit',
                        children: [
                            {
                                path: 'default',
                                component: TransitComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'travel',
                        component: IndividualTravelComponent,
                        children: [
                            {
                                path: 'default',
                                component: IndividualTravelDefaultComponent,
                            },
                            {
                                path: 'flights',
                                component: IndividualFlightsComponent,
                            },
                            {
                                path: 'miles',
                                component: IndividualMilesComponent,
                            },
                            {
                                path: 'fuel',
                                component: IndividualFuelComponent,
                            },
                            {
                                path: 'length',
                                component: IndividualLengthComponent,
                            },
                            {
                                path: 'list',
                                component: IndividualFlightsListComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ]
                    },
                    {
                        path: 'home',
                        component: EnergyComponent,
                        children: [
                            {
                                path: 'default',
                                component: EnergyDefaultComponent,
                            },
                            {
                                path: 'add',
                                component: EnergyAddComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'complete/thankyou',
                        component: ThankyouComponent,
                    },
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'vehicle'
                    }
                ],
            },
            {
                path: 'business',
                component: BusinessCalculatorComponent,
                children: [
                    {
                        path: 'gate/default',
                        component: BusinessGateComponent,
                    },
                    {
                        path: 'site',
                        component: SiteComponent,
                        children: [{
                            path: 'default',
                            component: SiteDefaultComponent
                        }, {
                            path: 'add',
                            component: SiteAddComponent
                        }, {
                            path: '',
                            pathMatch: 'full',
                            redirectTo: 'default'
                        }]
                    },
                    {
                        path: 'fleet',
                        component: FleetComponent,
                        children: [{
                            path: 'default',
                            component: FleetDefaultComponent
                        }, {
                            path: 'car',
                            component: FleetCarComponent
                        }, {
                            path: 'truck',
                            component: FleetCarComponent
                        }, {
                            path: 'deliveryTruck',
                            component: FleetCarComponent
                        }, {
                            path: 'semi',
                            component: FleetCarComponent
                        }, {
                            path: 'boat',
                            component: FleetBoatComponent
                        }, {
                            path: 'ecar',
                            component: FleetEcarComponent
                        }, {
                            path: 'list',
                            component: FleetListComponent,
                        }, {
                            path: '',
                            pathMatch: 'full',
                            redirectTo: 'default'
                        }]
                    },
                    {
                        path: 'travel',
                        component: AirTravelComponent,
                        children: [
                            {
                                path: 'default',
                                component: AirTravelDefaultComponent
                            }, {
                                path: 'employee',
                                component: AirTravelEmployeeComponent
                            }, {
                                path: 'miles',
                                component: AirTravelMilesComponent
                            }, {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'commute',
                        children: [
                            {
                                path: 'default',
                                component: CommuteComponent
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'shipping',
                        children: [
                            {
                                path: 'default',
                                component: ShippingComponent
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'server',
                        children: [
                            {
                                path: 'default',
                                component: ServerComponent
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    }, {
                        path: 'complete/thankyou',
                        component: ThankyouComponent,
                    }, {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'gate/default'
                    }
                ],
            },
            {
                path: 'events',
                component: EventsCalculatorComponent,
                children: [
                    {
                        path: 'gate/default',
                        component: EventsGateComponent,
                    },
                    {
                        path: 'travel',
                        component: EventsTravelComponent,
                        children: [
                            {
                                path: 'default',
                                component: EventsTravelDefaultComponent,
                            },
                            {
                                path: 'length',
                                component: EventsLengthComponent,
                            },
                            {
                                path: 'average',
                                component: EventsAverageComponent
                            },
                            {
                                path: 'hotel',
                                component: HotelComponent
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'commute',
                        children: [
                            {
                                path: 'default',
                                component: EventsCommuteComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'venue',
                        children: [
                            {
                                path: 'default',
                                component: VenueComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'water',
                        children: [
                            {
                                path: 'default',
                                component: WaterComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'meals',
                        children: [
                            {
                                path: 'default',
                                component: MealsComponent,
                            },
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'default'
                            }
                        ],
                    },
                    {
                        path: 'complete/thankyou',
                        component: ThankyouComponent,
                    },
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'gate/default'
                    }
                ],
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'individual'
            }
        ],
    },
    {
        path: 'limit',
        component: LimitComponent,
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: ''
    }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, {useHash: true});




// WEBPACK FOOTER //
// ./src/app/components/app.routes.ts